export const journeyColumnTemplate = 'col-12 col-sm-8 offset-sm-2';
